import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  // Servidores
  //private REST_API_SERVER = "http://ec2-54-174-229-173.compute-1.amazonaws.com:4001/api/v1/";
  private REST_API_SERVER = "https://vko7erknrj.execute-api.us-east-1.amazonaws.com/prod/";
  //private REST_API_SERVER = "http://localhost:4001/api/v1/";

  constructor(private httpClient: HttpClient) { }

  // Modificação aqui: Adicionado payload opcional ao método getTypeRequest
  getTypeRequest(url, payload?: any) {
    let params = new HttpParams();
    if (payload) {
      for (let key in payload) {
        if (payload.hasOwnProperty(key)) {
          params = params.set(key, payload[key]);
        }
      }
    }

    return this.httpClient.get(this.REST_API_SERVER + url, { params: params }).pipe(map(res => {
      return res;
    }));
  }

  postTypeRequest(url, payload?: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });

    let body = new URLSearchParams();
    for (let key in payload) {
      if (payload.hasOwnProperty(key)) {
        body.set(key, payload[key]);
      }
    };

    return this.httpClient.post(this.REST_API_SERVER + url, body.toString(), { headers: headers }).pipe(map(res => {
      return res;
    }));
  }

  postTypeRequestJson(url, payload?: any, queryParams: any = {}) {

    // Monta a baseURL
    let baseUrl = this.REST_API_SERVER + url;

    // Remove o ? final se existir
    if (baseUrl.endsWith('?')) {
      baseUrl = baseUrl.slice(0, -1);
    }

    // Construa a URL com os parâmetros de consulta
    let queryString = Object.keys(queryParams)
      .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(queryParams[key])}`)
      .join('&');

    const fullUrl = `${this.REST_API_SERVER + url}?${queryString}`;

    return this.httpClient.post(fullUrl, payload).pipe(map(res => {
      return res;
    }));
  }

  putTypeRequest(url, payload?: any) {
    return this.httpClient.put(this.REST_API_SERVER + url, payload).pipe(map(res => {
      return res;
    }));
  };

  deleteTypeRequest(url) {
    return this.httpClient.delete(this.REST_API_SERVER + url).pipe(map(res => {
      return res;
    }));
  };

}
